import { defineMessages } from "react-intl";

export const messages = defineMessages({
  appleLogin: {
    id: "appleSignInButton.appleLogin",
    description: "Text on the button to log in with apple account",
    defaultMessage: "Continue with Apple",
  },
});
